// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search--WLx85{position:sticky;top:-20px;z-index:1;margin:-20px -24px 8px;padding:20px 24px 16px;background-color:#fff;border-bottom:1px solid #f0f0f4}.tool-list--UfWk_{gap:12px}.tool-tile--YjL2Z{border:1px solid #f0f0f4}.tool-name--utLDP{font-size:15px}.tool-icon--UopX2{font-size:18px}.tool-id--jwDrw{font-size:12px}.tool-description--Aipvb{line-height:1.45;white-space:pre-wrap}.parameters-heading--w15DN{font-size:11px;letter-spacing:.04em}.child-conversation-picker--mABHv{min-width:180px}.parameters--im08b{gap:12px;padding-left:12px;border-left:2px solid #f0f0f4;margin-left:2px}.parameter-name--XyNib{font-size:13px}.parameter-description--TJKal{font-size:13px;line-height:1.4}.parameter-values--Y6v3t{font-size:12px}.show-more-button--QkfTc{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": "search--WLx85",
	"tool-list": "tool-list--UfWk_",
	"tool-tile": "tool-tile--YjL2Z",
	"tool-name": "tool-name--utLDP",
	"tool-icon": "tool-icon--UopX2",
	"tool-id": "tool-id--jwDrw",
	"tool-description": "tool-description--Aipvb",
	"parameters-heading": "parameters-heading--w15DN",
	"child-conversation-picker": "child-conversation-picker--mABHv",
	"parameters": "parameters--im08b",
	"parameter-name": "parameter-name--XyNib",
	"parameter-description": "parameter-description--TJKal",
	"parameter-values": "parameter-values--Y6v3t",
	"show-more-button": "show-more-button--QkfTc"
};
export default ___CSS_LOADER_EXPORT___;
